import React, { useState } from 'react';
import { fetchData, postData, deleteData, activateData } from '../../../apiService';
import { Button } from '@mui/material';
import { useHistory, Link } from 'react-router-dom';

const SubscriptionForm = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const history = useHistory();

    const [formData, setFormData] = useState({
        Name: '',
        Description: '',
        Amount: '',
        PlanDuration: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     console.log('Submitted:', formData);
    //     // Add API call or validation here
    // };

    const durationOptions = [
        { label: '28 Days', value: '28' },
        { label: '168 Days', value: '168' },
        { label: 'Yearly (365 Days)', value: '365' },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.Name) {
            setErrorMessage('Name is required !');
            setIsLoading(false);
            return;
        }
        if (!formData.PlanDuration) {
            setErrorMessage('Plan is required !');
            setIsLoading(false);
            return;
        }
        if (!formData.Amount) {
            setErrorMessage('Amount is required !');
            setIsLoading(false);
            return;
        }
        if (!formData.Description) {
            setErrorMessage('Description is required !');
            setIsLoading(false);
            return;
        }

        const CreateData = {
            ...formData,
            CreatedBy: 1,
            CompanyId: 1,
            CreatedDate: new Date(),
        };

        postData('SubscriptionPlansApi', CreateData) //, token
            .then((response) => {
                console.log('Subscription Plans Created success:', response);
                setSuccessMessage("Subscription Plans Created successfully!");
                setErrorMessage("");
                setFormData({
                    Name: '',
                    Description: '',
                    Amount: '',
                    PlanDuration: '',
                });
                setIsLoading(false);
                window.location.reload();
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Subscription Plan Create error:', error);
                setIsLoading(false);
            });
    };

    const commonButtonStyles = {
        height: '36px',
        marginLeft: '10px',
        marginTop: '10px',
        marginRight: '8px',
    };

    const [isHovered, setIsHovered] = useState(false);

    const baseStyles = {
        width: "100%",
        padding: "10px",
        marginTop: "15px",
        borderRadius: "8px",
        border: "1px solid #fff",
        background: loading
            ? "#fff"
            : isHovered
                ? "#c5ec7bff" // light green on hover
                : "transparent",
        color: loading
            ? "#000"
            : isHovered
                ? "#000" // text turns black on hover
                : "#fff",
        fontWeight: "bold",
        cursor: loading ? "not-allowed" : "pointer",
        transition: "all 0.3s ease",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
    };

    return (
        <div className="max-w-md mx-auto p-6  rounded-xl shadow-lg mt-10"
            style={{
                borderRadius: '10px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                backgroundColor: 'rgba(255, 255, 255, 0.2)', // transparent white
                backdropFilter: 'blur(10px)', // optional glass effect
                WebkitBackdropFilter: 'blur(10px)', // for Safari
            }}
        >
            <div className="flex items-center justify-between mb-4">
                <h5 className="font-bold text-green-800 text-center flex-1" style={{ fontFamily: 'monospace', textTransform: 'uppercase', color: 'whitesmoke' }}>
                    Subscription Plan
                </h5>

                <Button
                    style={{ ...commonButtonStyles, backgroundColor: '#ec842fff', color: 'whitesmoke' }}
                    component={Link}
                    to="/SubscriptionIndex"
                    className="linkcolor ml-auto"
                    onClick={() => localStorage.setItem('shouldReloadCreatePage', 'true')}
                >
                    <span>Back to list</span>
                </Button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">

                <div className='m-2'>
                    <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase' }}>Name</label>
                    <input
                        type="text"
                        name="Name"
                        required
                        className="w-full px-4 py-2 border rounded-md"
                        value={formData.Name}
                        onChange={handleChange}
                        style={{
                            width: "100%",
                            padding: "10px 10px 10px 40px",
                            borderRadius: "8px",
                            border: "1px solid #4c6793",
                            background: "#2E2E2E",
                            color: "#fff",
                            outline: "none",
                            transition: "border 0.3s ease",
                        }}
                    />
                </div>

                <div className='m-2'>
                    <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase' }}>Description</label>
                    <textarea
                        name="Description"
                        rows="3"
                        required
                        className="w-full px-4 py-2 border rounded-md"
                        value={formData.Description}
                        onChange={handleChange}
                        style={{
                            width: "100%",
                            padding: "10px 10px 10px 40px",
                            borderRadius: "8px",
                            border: "1px solid #4c6793",
                            background: "#2E2E2E",
                            color: "#fff",
                            outline: "none",
                            transition: "border 0.3s ease",
                        }}
                    />
                </div>

                <div className='m-2'>
                    <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase' }}>Amount (₹)</label>
                    <input
                        type="number"
                        name="Amount"
                        required
                        className="w-full px-4 py-2 border rounded-md"
                        value={formData.Amount}
                        onChange={handleChange}
                        style={{
                            width: "100%",
                            padding: "10px 10px 10px 40px",
                            borderRadius: "8px",
                            border: "1px solid #4c6793",
                            background: "#2E2E2E",
                            color: "#fff",
                            outline: "none",
                            transition: "border 0.3s ease",
                        }}
                    />
                </div>

                <div className='m-2'>
                    <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase' }}>Plan Duration</label>
                    <select
                        name="PlanDuration"
                        required
                        className="w-full px-4 py-2 border rounded-md"
                        value={formData.PlanDuration}
                        onChange={handleChange}
                        style={{
                            width: "100%",
                            padding: "10px 10px 10px 40px",
                            borderRadius: "8px",
                            border: "1px solid #4c6793",
                            background: "#2E2E2E",
                            color: "#fff",
                            outline: "none",
                            transition: "border 0.3s ease",
                        }}
                    >
                        <option value="">-- Select Duration --</option>
                        {durationOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>
                <div className='m-4'>
                    {/* <button
                        type="submit"
                        className="w-full bg-green-700 text-white py-2 rounded hover:bg-green-800 transition"
                        style={{ color: 'white', fontFamily: 'monospace', textTransform: 'uppercase', fontWeight: 'bold', backgroundColor: 'darkslateblue', borderRadius: '5px', padding: '10px 20px', cursor: 'pointer', border: 'none', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}
                    >
                        Save Subscription
                    </button> */}
                    <div className='m-4'>
                        <button
                            type="submit"
                            disabled={loading}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            style={baseStyles}
                        >
                            Save Subscription
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default SubscriptionForm;
